module.exports = __webpack_public_path__ + "img/voet_logo-1405x41.a3311fd3.svg";